import { Badge, Card, CardContent, Spinner } from '@crm/ui';
import {
  ArrowLeft,
  BadgeCheck,
  Building2,
  ChartNoAxesColumn,
  CircleAlert,
  IdCard,
  Receipt,
} from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { EmptyState, PageHeader, TabPages } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { SAAS_ROUTES, useSubscriber, useSubscriberPendencies } from '../api';
import { SubscriberData } from '../components/subscriber-data';
import { SubscriberMetrics } from '../components/subscriber-metrics';
import { SubscriberPayments } from '../components/subscriber-payments';
import { SubscriberPendencies } from '../components/subscriber-pendencies';
import { SubscriberPlan } from '../components/subscriber-plan';

export function SubscriberPage() {
  const { id = '' } = useParams();
  const detail = useSubscriber(id);
  const pendencies = useSubscriberPendencies(id);

  useDocumentTitle(detail.data?.subscriber.name ?? 'Assinante');

  const emAberto = pendencies.data?.pending ?? 0;

  if (detail.isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner className="h-6 w-6 text-muted-foreground" />
      </div>
    );
  }

  if (!detail.data) {
    return (
      <Card variant="flush">
        <CardContent className="py-6">
          <EmptyState icon={<Building2 />} title="Assinante nao encontrado" />
        </CardContent>
      </Card>
    );
  }

  const { subscriber, plan } = detail.data;

  return (
    <div className="space-y-4">
      <Link
        to={SAAS_ROUTES.SUBSCRIBERS}
        className="-ml-1 mb-1 inline-flex min-h-10 items-center gap-1.5 px-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" />
        Assinantes
      </Link>

      <PageHeader
        icon={<Building2 />}
        title={subscriber.name}
        description={plan ? `Plano ${plan.name}` : 'Sem plano contratado'}
        actions={
          subscriber.isActive ? null : (
            <Badge variant="outline" className="border-destructive/50 text-destructive">
              Inativo
            </Badge>
          )
        }
      />

      <TabPages
        label="Aba do assinante"
        pages={[
          {
            key: 'dados',
            label: 'Dados',
            icon: IdCard,
            render: () => <SubscriberData detail={detail.data} />,
          },
          {
            key: 'metricas',
            label: 'Metricas',
            icon: ChartNoAxesColumn,
            render: () => <SubscriberMetrics id={id} />,
          },
          {
            key: 'pendencias',
            label: emAberto > 0 ? `Pendencias (${emAberto})` : 'Pendencias',
            icon: CircleAlert,
            render: () => <SubscriberPendencies id={id} />,
          },
          {
            key: 'plano',
            label: 'Plano',
            icon: BadgeCheck,
            render: () => <SubscriberPlan detail={detail.data} />,
          },
          {
            key: 'pagamentos',
            label: 'Pagamentos',
            icon: Receipt,
            render: () => <SubscriberPayments id={id} />,
          },
        ]}
      />
    </div>
  );
}
